import React from 'react'
import { connect } from 'react-redux'
import withNavigate from '../../../components/common/withNavigate'
import SSOSignIn from './SSO-SignIn'
import SSOSuccess from './SSO-Success'

class SSO extends React.Component {
  state = {
    page: 'signIn',
  };

  switchPage(page) {
    this.setState({page})
  }

  renderSwitch(page) {
    switch(page) {
      case 'signIn':
        return <SSOSignIn onSuccess={()=>{this.switchPage('success')}} product={this.props.product} />;
      case 'success':
        return <SSOSuccess product={this.props.product} />
      default:
        return <SSOSignIn product={this.props.product} />;
    }
  }

  render () {
    return (
      <div className='login container py-5 h-100'>
        <div className='row d-flex justify-content-center p-3'>
          <div className='col-xl-4'>
            <form>
              <div className='header text-center'>
                <h2>ScreenBeam Cloud</h2>
              </div>
              {this.renderSwitch(this.state.page)}
            </form>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(withNavigate(SSO))
